<template>
  <div>
    <div class="notification-center">
      <transition-group name="fade" mode="out-in">
        <template v-for="(notification, i) in listNotifications">
          <notification :notification="notification" :key="i" :index="i"></notification>
        </template>
      </transition-group>
    </div>
    <sound-notification />
  </div>
</template>

<script>
import Notification from '@/components/Notifications/Notification.vue'
import SoundNotification from '@/components/Notifications/Sound.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Notification,
    SoundNotification
  },
  computed: {
    ...mapState({
      listNotifications: state => state.NotificationModule.listNotifications
    })
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.notification-center {
  position: fixed;
  bottom: $margin-milli;
  left: 0;
  padding: 0 $margin-base;
  z-index: 10;
}
</style>